import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import RatingEmoji from "../RatingEmoji";
import {
  Wrapper,
  Rating,
  Input,
  Label,
  Title,
  StepCount,
} from "../styles/rating-steps-styles";

interface IProfessionalismProps {
  setRating: (event) => void;
  rating: number;
}

const Professionalism: FunctionComponent<IProfessionalismProps> = ({
  setRating,
  rating,
}) => (
  <Wrapper noPointerEvents={rating}>
    <RatingEmoji rating={rating} />
    <Title className="animated delay fadeInDown">Professionalism</Title>
    <Rating className="rating animated delay fadeInDown">
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step4Rating"
        id="rating-45"
        value={5}
      />
      <Label htmlFor="rating-45" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step4Rating"
        id="rating-44"
        value={4}
      />
      <Label htmlFor="rating-44" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step4Rating"
        id="rating-43"
        value={3}
      />
      <Label htmlFor="rating-43" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step4Rating"
        id="rating-42"
        value={2}
      />
      <Label htmlFor="rating-42" />
      <Input
        onClick={(e) => setRating(e)}
        type="radio"
        name="step4Rating"
        id="rating-41"
        value={1}
      />
      <Label htmlFor="rating-41" />
    </Rating>
    <StepCount>step 4 of 5</StepCount>
  </Wrapper>
);

Professionalism.propTypes = {
  setRating: PropTypes.func.isRequired,
  rating: PropTypes.number,
};

Professionalism.defaultProps = {
  rating: null,
};
export default Professionalism;
